import {Component, OnInit} from "@angular/core";
import {DOCUMENT_TYPES, DOCUMENT_TYPES_LIST, VALUE_TYPE} from "../../enums/enums";
import {CollectionService} from "../../services/collection.service";
import {paramsHelper} from "../../helpers/params-helper";
import {canCast} from "../../utils";
import {SEARCH_PROP_TYPES} from "../../enums/e-search";
import {ISearchItem} from "../../definitions";
import {createObjectLink, createObjectLinkQuery} from "../../helpers/create-object-link";
import {localeUtils} from "../../helpers/locale-utils";
import * as JSON_Query from "json-query";


@Component({
  selector: 'app-search-page',
  templateUrl: './search-page.component.html',
  styles: []
})
export class SearchPageComponent implements OnInit {
  DOCUMENT_TYPES_LIST = [{id:null, label: "----"}].concat(DOCUMENT_TYPES_LIST.filter(type => type.id != DOCUMENT_TYPES.ATLAS));//atlases are in the separate collection
  VALUE_TYPE = VALUE_TYPE;
  search = {
    id: "",
    _id: "",
    name: null,
    _type: []
  };
  result: ISearchItem[] = [];
  localeUtils = localeUtils;


  constructor(private collectionService: CollectionService) {
    // getUiText("hello", 22, "hello");
  }


  ngOnInit() {
  }


  onKeyPress(event: KeyboardEvent) {
    if (event.keyCode === 13) {
      this.onSearchClick();
    }
  }


  createItemLink(item: ISearchItem) {
    return createObjectLink(item);
  }


  createItemLinkQuery(item: ISearchItem) {
    return createObjectLinkQuery(item);
  }


  onSearchClick() {
    const searchParams = paramsHelper.search();

    if (this.search.id.length > 0 && canCast("" + this.search.id, VALUE_TYPE.INT)) {
      searchParams.addParam("id", SEARCH_PROP_TYPES.NUMBER, +this.search.id);
    }

    if (this.search._id.length > 0 && /^[a-fA-F0-9]{24}$/.test(this.search._id)) {
      searchParams.addParam("_id", SEARCH_PROP_TYPES.OBJECT_ID, this.search._id);
    }


    if (this.search._type.length > 0) {
      const filtered = this.search._type.filter(i => i !== null);
      if (filtered.length > 0) {
        searchParams.addParam("_type", SEARCH_PROP_TYPES.STRING, this.search._type);
      }
    }

    if (this.search.name) {
      searchParams.addParam(`locales.${localeUtils.getLocale()}.name`, SEARCH_PROP_TYPES.LOCALE, this.search.name);
    }

    const t = paramsHelper.loader()
      .setEndpointApi()
      .setSearchParams(searchParams.json);
    this.collectionService.search(t)
      .subscribe(
        r => {this.result = r; console.log(JSON.stringify(r))});
  }

  getItemLabel(item){
    return localeUtils.findValue("name", item);
    //return JSON_Query(`locales.${localeUtils.getLocale()}.[key=name].value.0`, {data:item}).value;
  }


}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/search-page/search-page.component.ts